import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeight = (props) => /* @__PURE__ */ _jsxs("svg", {
	baseProfile: "basic",
	id: "ic.ruler",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		id: "Rectangle",
		fill: "none",
		width: 24,
		height: 24
	}), /* @__PURE__ */ _jsxs("g", {
		id: "Group",
		transform: "translate(4 3)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Rectangle-2",
				children: [/* @__PURE__ */ _jsx("path", {
					fill: "none",
					d: "M2,0h4c1.1,0,2,0.9,2,2v14c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z"
				}), /* @__PURE__ */ _jsx("path", {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5,
					strokeLinejoin: "round",
					d: "M2,0.8h4c0.7,0,1.2,0.6,1.2,1.2v14 c0,0.7-0.6,1.2-1.2,1.2H2c-0.7,0-1.2-0.6-1.2-1.2V2C0.8,1.3,1.3,0.8,2,0.8z"
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_3",
				fill: "currentColor",
				stroke: "currentColor",
				strokeLinejoin: "round",
				d: "M13,0.5L11,3h4L13,0.5z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_3_Copy",
				fill: "currentColor",
				stroke: "currentColor",
				strokeLinejoin: "round",
				d: "M13,17.5L11,15h4L13,17.5z"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Rectangle-3",
				transform: "translate(4 13)",
				children: [/* @__PURE__ */ _jsx("rect", {
					fill: "none",
					width: 4,
					height: 1
				}), /* @__PURE__ */ _jsx("polygon", {
					fill: "none",
					stroke: "currentColor",
					strokeLinejoin: "round",
					points: "0.5,0.5 3.5,0.5 3.5,0.5  "
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Rectangle_Copy",
				transform: "translate(4 10)",
				children: [/* @__PURE__ */ _jsx("rect", {
					fill: "none",
					width: 4,
					height: 1
				}), /* @__PURE__ */ _jsx("polygon", {
					fill: "none",
					stroke: "currentColor",
					strokeLinejoin: "round",
					points: "0.5,0.5 3.5,0.5 3.5,0.5  "
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Rectangle_Copy_2",
				transform: "translate(4 7)",
				children: [/* @__PURE__ */ _jsx("rect", {
					fill: "none",
					width: 4,
					height: 1
				}), /* @__PURE__ */ _jsx("polygon", {
					fill: "none",
					stroke: "currentColor",
					strokeLinejoin: "round",
					points: "0.5,0.5 3.5,0.5 3.5,0.5  "
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Rectangle_Copy_3",
				transform: "translate(4 4)",
				children: [/* @__PURE__ */ _jsx("rect", {
					fill: "none",
					width: 4,
					height: 1
				}), /* @__PURE__ */ _jsx("polygon", {
					fill: "none",
					stroke: "currentColor",
					strokeLinejoin: "round",
					points: "0.5,0.5 3.5,0.5 3.5,0.5  "
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2_Copy",
				fill: "none",
				stroke: "currentColor",
				d: "M13,2v14"
			})
		]
	})]
});
export default SvgHeight;
